import React, { useState, useEffect } from "react";

export const Nav = ({ themeMode, loading }) => {


  const [navElement, setnavElement] = useState(document.activeElement);
  const [darkMode, setTheme] = useState(false);

  useEffect(() => {
    var myNavBar = document.getElementById("nav");
    setnavElement(myNavBar);
  }, [navElement])

  window.onscroll = function () {
    if (
      document.body.scrollTop >= 200 ||
      document.documentElement.scrollTop >= 200
    ) {
      navElement.classList.add("nav-colored");
      navElement.classList.remove("nav-transparent");
    } else {
      navElement.classList.add("nav-transparent");
      navElement.classList.remove("nav-colored");
    }
  };

  async function themeChange() {
    setTheme(!darkMode);
    await themeMode(darkMode);
  }
  const shownav = () => {
    let nav = document.querySelector(".nav-links");
    let navLinks = document.querySelectorAll(".nav-links li");
    nav.classList.toggle("nav-active");
    let menu = document.getElementById("menu");
    navLinks.forEach((a, index) => {
      console.log(index / 7);
      if (a.style.animation) {
        a.style.animation = "";
      } else {
        a.style.animation = `navLinkfade 0.5s ease ${index / 5 + 0.3}s`;
      }
    });
    menu.classList.toggle("toggle");
  };
  return (
    <div>
      <header>
        <nav id="nav">
          <div className="logo">
            <a href="#footer">
              <img id="logo-img" src="/img/me.jpg" alt="me" width="50px" height="auto" style={{ margin: "12px", borderRadius: "100px" }} />
            </a>
          </div>
          <ul className="nav-links">
            <li onClick={themeChange}>
              <a style={{ marginTop: "30px" }}>
                {darkMode ? <img src="/img/summer.svg" width="20px" id="themeIcon" alt="" /> : <img src="/img/moon.svg" width="20px" id="themeIcon" alt="" />}
              </a>
            </li>
            <li>
              <a href="/#home">Home</a>
            </li>
            <li>
              <a href="/#about">About us</a>
            </li>

            <li>
              <a href="/#skills">Skills</a>
            </li>
            <li>
              <a href="/#project">Projects</a>
            </li>
            <li>
              <a href="/#contect">
                <button className="button-outline">Hire Me</button>
              </a>
            </li>
          </ul>
          <div role="button" className="menu" id="menu" onClick={shownav}>
            <div className="line1"></div>
            <div className="line2"></div>
            <div className="line3"></div>
          </div>
        </nav>
      </header>
    </div>
  );
};
